<template>
  <div
    class="px-6 md:px-8 pt-3 md:pt-6 pb-6 md:pb-8 bg-racq-anti-flash-white rounded flex-col justify-start items-start gap-4 flex"
  >
    <div class="flex-col justify-start items-start gap-0.5 flex">
      <div class="text-racq-med-grey text-lg-bold">
        <Text :field="fields.title" />
      </div>
      <RichText :field="{ value: coverageLabel }" class="text-racq-med-grey text-base" />
    </div>
    <div class="self-stretch flex-col justify-start items-start gap-5 flex">
      <div class="self-stretch justify-end items-start gap-4 md:gap-6 flex flex-col md:flex-row">
        <div class="grow shrink basis-0 justify-start items-end gap-1 flex">
          <div v-if="fields.icon?.value?.src" class="flex items-center justify-center h-[32px] w-[32px] self-center">
            <Image :media="fields.icon" />
          </div>
          <div class="text-center text-racq-dark-grey text-xl4-bold">
            {{
              quote.paymentFrequency === PaymentFrequency.Monthly
                ? formatCurrency(quote.insuranceQuoteSummary?.monthlyDeposit ?? 0, 2)
                : formatCurrency(quote.insuranceQuoteSummary?.yearlyAnnualPremium ?? 0, 2)
            }}
          </div>
          <div class="pb-1 justify-start items-center gap-2.5 flex">
            <div class="text-racq-med-grey text-m">
              {{ quote.paymentFrequency === PaymentFrequency.Monthly ? fields.monthly.value : fields.annually.value }}
            </div>
          </div>
        </div>
        <div class="grow shrink basis-0 flex-col justify-start items-start inline-flex">
          <Tag
            :tagText="quoteRefText"
            :tagType="TagTypes.noIcon"
            :tagSize="TagSize.lg"
            :tagBgColour="TagBgColour.trueWhite"
            :tagBorderColour="TagBorderColour.lightblue"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { Text, RichText, Field, Image } from '@sitecore-jss/sitecore-jss-vue';
import { ImageField } from '@sitecore-jss/sitecore-jss-vue/types/components/Image';
import { formatCurrency } from '@/utils/text-transforms';
import Tag from '@/components/Tag/Tag.vue';
import { TagTypes, TagSize, TagBorderColour, TagBgColour } from '@/enums/tag-enums';
import { IQuote, PaymentFrequency } from '@/interfaces';

const props = defineProps<{
  fields: {
    title: Field<string>;
    icon: ImageField;
    quoteRefText: Field<string>;
    monthly: Field<any>;
    annually: Field<any>;
  };
  quote: Partial<IQuote>;
  coverageLabel?: string;
}>();

const quoteRefText = computed(() => props.fields.quoteRefText.value.replace('{{quoteRef}}', props.quote.reference!));
</script>
